import { Component, Input } from '@angular/core';

import { HisUiService } from 'hisng';

import { PatentInventor } from 'app/fs/res/patent/model/patent/patent-classes';

@Component( {
    selector: 'res-patent-edit-inventor-percentage',
    templateUrl: './patent-edit-inventor-percentage.component.html',
} )
export class PatentEditInventorPercentageComponent {
    @Input() patentInventor: PatentInventor;

    constructor( private hisUiService: HisUiService ) { }

    public getPersonName(): string {
        let personName = '';
        if ( this.patentInventor.person !== null && !!this.patentInventor.person.id )  {
            personName = ' ' + this.hisUiService.translate('de.his.javang.aktionen.von')
                + ' ' + this.patentInventor.person?.firstname + ' ' + this.patentInventor.person?.surname;
        }
        return personName;
    }
}
